import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { toggleDialog } from 'actions/view'
import Button from 'components/theme/Button'
import InboxAiResponse from './InboxAiResponse'
import {
  overrideSmsInput,
  toggleMessageMenu,
  changeTo,
  sendSmsInboxDefault,
} from 'actions/inbox'
import { deleteEntity } from 'actions/data'
import { DATA_API_URL } from 'utils/AllURLs'

export default withRouter(
  connect(
    state => ({
      loading: Boolean(state.InboxAI.loadingInboxResponse),
      dialogOpen: state.view.dialogs?.InboxAiResponse?.open,
      id: Object.keys(state.data?.openaiinboxresponse || {})?.[0],
      content: Object.values(state.data?.openaiinboxresponse || {})?.[0]?.message
        ?.content,
      to: state.view.dialogs?.InboxAiResponse?.to,
    }),
    dispatch =>
      bindActionCreators(
        {
          toggleDialog,
          overrideSmsInput,
          toggleMessageMenu,
          deleteEntity,
          changeTo,
          sendSmsInboxDefault,
        },
        dispatch,
      ),
  )(
    withMobileDialog()(
      withStyles(theme => ({
        rounded: {
          borderRadius: 28,
          overflowY: 'hidden',
          // height: '100%',
          [theme.breakpoints.down('sm')]: {
            borderRadius: 0,
            overflowY: 'auto',
          },
        },
        dialogContentRoot: {
          padding: 0,
          '&:first-child': {
            paddingTop: 0,
          },
        },
      }))(
        ({
          fullScreen,
          dialogOpen,
          classes,
          toggleDialog,
          history,
          overrideSmsInput,
          content,
          deleteEntity,
          id,
          toggleMessageMenu,
          changeTo,
          to,
          sendSmsInboxDefault,
          loading,
        }) => {
          return (
            <Dialog
              fullWidth
              maxWidth="sm"
              fullScreen={fullScreen}
              open={Boolean(dialogOpen)}
              onClose={() => {
                toggleDialog({
                  open: false,
                  dialog: 'InboxAiResponse',
                })

                if (id) {
                  deleteEntity(
                    id,
                    'openaiinboxresponse',
                    `${DATA_API_URL}/openaiinboxresponse/${id}`,
                    'none',
                  )
                }
              }}
              aria-labelledby="responsive-dialog-title"
              PaperProps={{ classes: { rounded: classes.rounded } }}
            >
              <DialogContent classes={{ root: classes.dialogContentRoot }}>
                <InboxAiResponse />
              </DialogContent>
              <DialogActions>
                <Button
                  disabled={loading}
                  onClick={() => {
                    changeTo('text', to).then(() => {
                      sendSmsInboxDefault(content, to)
                      toggleDialog({
                        open: false,
                        dialog: 'InboxAiResponse',
                      })

                      if (id) {
                        deleteEntity(
                          id,
                          'openaiinboxresponse',
                          `${DATA_API_URL}/openaiinboxresponse/${id}`,
                          'none',
                        )
                      }
                    })
                  }}
                  color="primary"
                >
                  Send now
                </Button>
                <Button
                  disabled={loading}
                  onClick={() => {
                    overrideSmsInput(content).then(() => {
                      changeTo('text', to)
                      toggleMessageMenu(true)
                      toggleDialog({
                        open: false,
                        dialog: 'InboxAiResponse',
                      })

                      if (id) {
                        deleteEntity(
                          id,
                          'openaiinboxresponse',
                          `${DATA_API_URL}/openaiinboxresponse/${id}`,
                          'none',
                        )
                      }
                    })
                  }}
                  color="primary"
                >
                  Edit
                </Button>
                <Button
                  onClick={() => {
                    toggleDialog({
                      open: false,
                      dialog: 'InboxAiResponse',
                    })

                    if (id) {
                      deleteEntity(
                        id,
                        'openaiinboxresponse',
                        `${DATA_API_URL}/openaiinboxresponse/${id}`,
                        'none',
                      )
                    }
                  }}
                  color="primary"
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )
        },
      ),
    ),
  ),
)
